module.exports = __webpack_public_path__ + "img/ML 12 - Sky.183df57b.png";